export const getRuntimeEnvironment = (
  hostname: string | undefined = window.location.hostname,
): "production" | "staging" => {
  if (
    hostname === "iwoca.co.uk" ||
    hostname?.endsWith(".iwoca.co.uk") ||
    hostname === "iwoca.de" ||
    hostname?.endsWith(".iwoca.de")
  ) {
    return "production";
  }

  return "staging";
};

export const getRuntimeRegion = (
  hostname: string | undefined = window.location.hostname,
): "uk" | "de" => {
  if (hostname === "iwoca.de" || hostname?.endsWith(".iwoca.de")) {
    return "de";
  }

  if (hostname === "iwoca-dev.de" || hostname?.endsWith(".iwoca-dev.de")) {
    return "de";
  }

  return "uk";
};
